import React from 'react';
import { withStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import NetworkIcon from 'components/Icons/Network';
import ProjectIcon from 'components/Icons/Project';
import SiteIcon from 'components/Icons/Site/Site';
import ZoneIcon from 'components/Icons/Zone';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import LoadingPanel from 'components/LoadingPanel';
import LocationPicker from '../LocationPicker';

import SelectionDialog from 'components/SelectionDialog';
import isNotNullOrEmpty from 'utilities/is/isNotNullOrEmpty';
import styles from './styles';

class LocationPanel extends React.Component {
    state = {
        projectDialogOpen: false,
        siteDialogOpen: false,
        zoneDialogOpen: false,
    };

    handleDivisionClicked = () => {
        this.props.onLoadDivisions();        
    };

    handleDivisionSelected = (division, index) => {
        this.props.onDivisionSelected(division, index);
        this.props.onCloseDivisionDialog();
    };

    handleProjectSelected = (project, index) => {
        this.props.onProjectSelected(project, index);
        this.setState({ projectDialogOpen: false });
    };

    handleSiteSelected = (site, index) => {
        this.props.onSiteSelected(site, index);
        this.setState({ siteDialogOpen: false });
    };

    handleZoneSelected = (zone, index) => {
        this.props.onZoneSelected(zone, index);
        this.setState({ zoneDialogOpen: false });
    };

    render() {

        const {
            classes,
            selectedDivision,
            selectedProject,
            selectedSite,
            selectedZone,
            divisions,
            divisionName,
            projects,
            sites,
            zones,
            divisionsLoading,
            divisionDataLoading } = this.props;

        const projectsToList = (selectedDivision && selectedDivision.divisionID) && projects ? projects[selectedDivision.divisionID] : null;
        const sitesToList = (selectedProject && selectedProject.projectID) && sites ? sites[selectedProject.projectID] : null;
        const zonesToList = (selectedSite && selectedSite.siteCode) && zones ? zones[selectedSite.siteCode] : null;

        return (
            <List>
                <SelectionDialog
                    open={this.props.divisionDialogOpen}
                    title={divisionName}
                    handleClose={() => this.setState({ divisionDialogOpen: false })}
                    items={divisions || []}
                    displayProp="divisionName"
                    itemIcon={
                        <ListItemAvatar>
                            <NetworkIcon />
                        </ListItemAvatar>
                    }
                    onItemSelected={this.handleDivisionSelected} />

                <SelectionDialog
                    open={this.state.projectDialogOpen}
                    title={this.props.projectName}
                    handleClose={() => this.setState({ projectDialogOpen: false })}
                    items={projectsToList}
                    displayProp="name"
                    itemIcon={
                        <ListItemAvatar>
                            <ProjectIcon />
                        </ListItemAvatar>
                    }
                    onItemSelected={this.handleProjectSelected} />

                <SelectionDialog
                    open={this.state.siteDialogOpen}
                    title={this.props.siteName}
                    handleClose={() => this.setState({ siteDialogOpen: false })}
                    items={sitesToList}
                    displayProp="name"
                    itemIcon={
                        <ListItemAvatar>
                            <SiteIcon />
                        </ListItemAvatar>
                    }
                    onItemSelected={this.handleSiteSelected} />

                <SelectionDialog
                    open={this.state.zoneDialogOpen}
                    title={this.props.zoneName}
                    handleClose={() => this.setState({ zoneDialogOpen: false })}
                    items={zonesToList}
                    displayProp="name"
                    itemIcon={
                        <ListItemAvatar>
                            <ZoneIcon />
                        </ListItemAvatar>
                    }
                    onItemSelected={this.handleZoneSelected} />

                {divisionsLoading &&
                    <LoadingPanel message={'Loading ' + this.props.divisionName} />
                }
                {!divisionsLoading &&
                    <React.Fragment>
                        <LocationPicker
                            selected={selectedDivision}
                            pickerName={this.props.divisionName}
                            displayProp="divisionName"
                            IconComponent={NetworkIcon}
                            avatarClass={classes.divisionAvatar}
                            disabled={divisionDataLoading}
                            onSelectionChanged={this.handleDivisionClicked} />
                        <Divider />
                    </React.Fragment>
                }
                {divisionDataLoading && selectedDivision &&
                    <LoadingPanel message={'Loading data for ' + selectedDivision.divisionName} />
                }
                {!divisionsLoading && !divisionDataLoading &&
                    <React.Fragment>
                        <LocationPicker
                            selected={selectedProject}
                            pickerName={this.props.projectName}
                            displayProp="projectName"
                            avatarClass={classes.projectAvatar}
                            IconComponent={ProjectIcon}
                            disabled={!isNotNullOrEmpty(projectsToList)}
                            onSelectionChanged={() => this.setState({ projectDialogOpen: true })} />

                        <Divider />

                        <LocationPicker
                            selected={selectedSite}
                            pickerName={this.props.siteName}
                            displayProp="siteName"
                            IconComponent={SiteIcon}
                            avatarClass={classes.siteAvatar}
                            disabled={!isNotNullOrEmpty(sitesToList)}
                            onSelectionChanged={() => this.setState({ siteDialogOpen: true })} />

                        <Divider />

                        <LocationPicker
                            selected={selectedZone}
                            IconComponent={ZoneIcon}
                            pickerName={`${this.props.zoneName} (Optional)`}
                            displayProp="zoneName"
                            avatarClass={classes.zoneAvatar}
                            disabled={!isNotNullOrEmpty(zonesToList)}
                            onSelectionChanged={() => this.setState({ zoneDialogOpen: true })} />
                    </React.Fragment>
                }

            </List>
        );
    }
}

const Styled = withStyles(styles)(LocationPanel);
export default Styled;
